import type { InternalAxiosRequestConfig } from 'axios';

/**
 * buyer-service verifies the Firebase ID token itself and reads identity from
 * custom claims UMS writes on the account. These two refusals mean "this token
 * is older than your claims": a token minted before UMS wrote them, or issued
 * before a role/org change or a disable. A force-refreshed token is current —
 * except for a disabled account, which cannot refresh at all. Mirrors
 * `REFRESHABLE_AUTH_ERROR_CODES` in packages/auth.
 */
export const REFRESHABLE_AUTH_CODES: readonly string[] = ['AUTH_CLAIMS_MISSING', 'AUTH_TOKEN_REVOKED'];

export type RetriableRequestConfig = InternalAxiosRequestConfig & { authRetried?: boolean };

interface MaybeAuthError {
    config?: RetriableRequestConfig;
    response?: { status?: number; data?: { code?: unknown } };
}

/** A 401 that a fresh token would fix, on a request not already retried once. */
export const shouldRetryWithFreshToken = (error: unknown): boolean => {
    const { config, response } = (error ?? {}) as MaybeAuthError;
    if (!config || config.authRetried) return false;
    return response?.status === 401 && REFRESHABLE_AUTH_CODES.includes(String(response.data?.code));
};
